import { useState } from "react";

import { useQuery } from "@apollo/client";
import { AutoComplete, SelectProps } from "antd";

import { QueryParams, PaginationResponse, RVFormItem } from "@regal-voice/ui";
import { AGENTS_QUERY_HARD_LIMIT, getAgentShared } from "Services/marketing-api/agents/queries";
import { Agent } from "Types/Agent";

const defaultQueryParams: QueryParams = {
    pageSize: AGENTS_QUERY_HARD_LIMIT,
    page: 0,
    orderBy: [
        {
            key: "name",
            value: "ASC",
        },
    ],
    filterBy: [],
};

export type TargetAgentAutoCompleteOptions = { value: string; label: string | JSX.Element };

export const autocompleteOptionMatchesValue: Extract<
    SelectProps<string, TargetAgentAutoCompleteOptions>["filterOption"],
    (...args: any[]) => any
> = (value, option) => {
    if (!option?.value) {
        return false;
    }
    return option.value.toLowerCase().indexOf(value.toLowerCase()) >= 0;
};
export function AssignTargetAgentFormItems(): JSX.Element {
    const [options, setOptions] = useState<TargetAgentAutoCompleteOptions[]>();
    useQuery(getAgentShared, {
        notifyOnNetworkStatusChange: true, // necessary for onCompleted to run after refetch
        fetchPolicy: "no-cache",
        variables: { queryParams: defaultQueryParams },
        onCompleted({ findAllAgents }: { findAllAgents: PaginationResponse<Agent> }) {
            if (!findAllAgents) {
                setOptions([]);
                return;
            }

            const { items } = findAllAgents;
            setOptions(items.map((mi) => renderItem(mi)));
        },
    });

    const renderItem = (agent: Agent) => ({
        value: `${agent.name} (${agent.email})`,
        label: (
            <div className="flex-row justify-between align-middle" key={agent.id} data-twilio-id={agent.id}>
                <span>
                    {agent.name} ({agent.email})
                </span>
            </div>
        ),
    });

    return (
        <>
            <RVFormItem
                name="targetAgent"
                label="Select Target Agent"
                rules={[
                    {
                        required: true,
                        message: "Target agent is required",
                    },
                ]}
            >
                <AutoComplete
                    popupClassName="certain-category-search-dropdown"
                    options={options}
                    filterOption={autocompleteOptionMatchesValue}
                    placeholder="Select Agent"
                    size="large"
                />
            </RVFormItem>
        </>
    );
}
